/**
 * SSC footer: "Cookie settings" reopens the preferences of Shopify's cookie banner.
 * The control stays hidden unless the banner script (window.privacyBanner) is present, so it never
 * renders as a dead button. Loads the Customer Privacy API first, as documented on shopify.dev
 * (docs/api/customer-privacy). Delegated listener, so it survives theme editor section re-renders.
 */

const ITEM_SELECTOR = '[data-ssc-cookie-item]';
const BUTTON_SELECTOR = '[data-ssc-cookie-settings]';

const bannerAvailable = () => typeof window.privacyBanner?.showPreferences === 'function';

function reveal() {
  if (!bannerAvailable()) return false;
  for (const item of document.querySelectorAll(ITEM_SELECTOR)) {
    if (item instanceof HTMLElement) item.hidden = false;
  }
  return true;
}

function showPreferences() {
  const open = () => {
    if (!bannerAvailable()) return;
    Promise.resolve(window.privacyBanner.showPreferences()).catch(() => {});
  };

  if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => open());
  } else {
    open();
  }
}

if (!reveal()) {
  // The banner script is injected by content_for_header and may finish after this module
  window.addEventListener('load', reveal, { once: true });
}

document.addEventListener('shopify:section:load', reveal);

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element) || !target.closest(BUTTON_SELECTOR)) return;
  event.preventDefault();
  showPreferences();
});
